var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.etapa)?_c('div',{staticClass:"d-inline"},[(_vm.mostrarIconeFinanceiro)?_c('span',{staticClass:"text-success ml-1"},[_c('i',{staticClass:"fa fa-check-circle fa-lg",attrs:{"title":"Processo Recebido/Quitado"}})]):_vm._e(),(_vm.mostrarStatus)?_c('app-status',{staticClass:"text-success ml-1",attrs:{"status":_vm.statusLabel}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }